import axios from '../utils/axios';

export default function createShowcaseCompany(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/showcase-companies', data)
    )
}
